import Fajr from './salaat/fajr'
import Dhuhr from './salaat/dhuhr'
import Jumuah from './salaat/jumuah'
import Asr from './salaat/asr'
import Maghrib from './salaat/maghrib'
import Esha from './salaat/esha'


export default [
    Fajr,
    Dhuhr,
    Jumuah,
    Asr,
    Maghrib,
    Esha
]